import { defineMessages } from 'react-intl';

/**
 * TWCG-2108 Loom Land opt-in — shared i18n strings for both modal variants.
 *
 * The pricing line uses an ICU `{price}` argument rather than a hard-coded "$5"
 * so the amount can change (or be localized to another currency) without editing
 * the copy. Callers pass the price through the component's `price` prop.
 */
export const messages = defineMessages({
	heading: {
		id: 'loomLandOptIn.heading',
		defaultMessage: 'Loom works better in a collection',
	},

	// Teamwork Collection (TWC) card
	twcSubtitle: {
		id: 'loomLandOptIn.twc.subtitle',
		defaultMessage: 'Get Loom plus Jira, Confluence, Rovo',
	},
	twcCta: {
		id: 'loomLandOptIn.twc.cta',
		defaultMessage: 'Try it free',
	},
	twcFeatureEmbed: {
		id: 'loomLandOptIn.twc.feature.embed',
		defaultMessage: 'Embed Loom videos in Jira project tasks',
	},
	twcFeatureNotes: {
		id: 'loomLandOptIn.twc.feature.notes',
		defaultMessage: 'Instantly capture meeting notes in Confluence',
	},
	twcFeaturePrice: {
		id: 'loomLandOptIn.twc.feature.price',
		defaultMessage: 'Access all apps for only {price} more per user / month',
	},
	// TWC edition is cheaper than the Loom edition.
	twcFeaturePriceLess: {
		id: 'loomLandOptIn.twc.feature.priceLess',
		defaultMessage: 'Access all apps for {price} less per user / month',
	},
	// Raw TWC price (Starter / free case).
	twcFeaturePriceAbsolute: {
		id: 'loomLandOptIn.twc.feature.priceAbsolute',
		defaultMessage: 'Access all apps for {price} per user / month',
	},
	twcFeatureTrial: {
		id: 'loomLandOptIn.twc.feature.trial',
		defaultMessage: 'Get Teamwork Collection free for 30 days',
	},

	// Loom-only card
	loomOnlyLabel: {
		id: 'loomLandOptIn.loomOnly.onlyLabel',
		defaultMessage: 'only',
	},
	loomOnlySubtitle: {
		id: 'loomLandOptIn.loomOnly.subtitle',
		defaultMessage: 'Try Loom as a standalone app',
	},
	loomOnlyCta: {
		id: 'loomLandOptIn.loomOnly.cta',
		defaultMessage: 'Continue with Loom only',
	},
	loomOnlyFeatureRecord: {
		id: 'loomLandOptIn.loomOnly.feature.record',
		defaultMessage: 'Record videos to share context or demos instantly',
	},
	loomOnlyFeatureRecaps: {
		id: 'loomLandOptIn.loomOnly.feature.recaps',
		defaultMessage: 'Get instant recaps from meetings',
	},
	loomOnlyFeatureShare: {
		id: 'loomLandOptIn.loomOnly.feature.share',
		defaultMessage: 'Share instantly with links that you can embed',
	},

	// Variant B "Continue with Loom" secondary CTA
	variantBLoomOnlyCta: {
		id: 'loomLandOptIn.variantB.loomOnlyCta',
		defaultMessage: 'Continue with Loom',
	},

	// Legal disclaimer (one per CTA wording). The <customerAgreement>,
	// <privacyPolicy> and <cancelAnytime> tags are rendered as inline links.
	legalTwc: {
		id: 'loomLandOptIn.legal.twc',
		defaultMessage:
			'By selecting “Try it free”, you agree to the <customerAgreement>Atlassian Customer Agreement</customerAgreement> and <privacyPolicy>Privacy Policy</privacyPolicy>. <cancelAnytime>Cancel anytime</cancelAnytime>.',
	},
	legalLoomOnly: {
		id: 'loomLandOptIn.legal.loomOnly',
		defaultMessage:
			'By selecting “Continue with Loom only”, you agree to the <customerAgreement>Atlassian Customer Agreement</customerAgreement> and <privacyPolicy>Privacy Policy</privacyPolicy>. <cancelAnytime>Cancel anytime</cancelAnytime>.',
	},
});

/** Default monthly per-user upsell price shown in the TWC pricing feature. */
export const DEFAULT_TWC_PRICE = '$5';
